import moment from 'moment'

const month = {
  getOptions () {
    const dt = moment()

    return Array.from({length: 12}, (val, i) => i + 1).map(num => {
      dt.set('month', num - 1)
      return {id: num, name: `${dt.format('MMMM')}`}
    })
  }
}

export {month}
